import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Block } from "@/components/Blocks";
import { ErrorState, LoadingBlock } from "@/components/states";
import { cmsCall } from "@/lib/cms";
import { blokkenVoorWeergave } from "@/lib/weergave";
import { useMobiel } from "@/hooks/useMobiel";

/**
 * Publieke pagina uit het CMS. Geen prijzen, geen live CRM-data;
 * productfoto's zijn gewone publieke <img>-URL's op het CRM.
 */
const CmsPage = ({ slug: vasteSlug }) => {
  const { t } = useTranslation();
  const mobiel = useMobiel();
  const { slug: routeSlug } = useParams();
  // Vaste slug (home/assortiment) of de slug uit de URL van een zelfgemaakte pagina.
  const slug = vasteSlug || routeSlug;
  const [page, setPage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    cmsCall("GET", `/content/pages/${slug}`)
      .then((data) => !cancelled && setPage(data))
      .catch((e) => !cancelled && setError(e.message || t("errors.generic")))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [slug, t]);

  if (loading) {
    return (
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
        <LoadingBlock />
      </div>
    );
  }
  if (error || !page) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <ErrorState message={error} />
      </div>
    );
  }

  return (
    <div data-testid={`cms-page-${page.slug}`}>
      {blokkenVoorWeergave(page.blokken || [], page.mobiel, mobiel).map((block, i) => (
        <Block key={block.id || i} block={block} />
      ))}
    </div>
  );
};

export default CmsPage;
